// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy-policy[data-v-9341a17a]{width:100%;height:100vh;overflow-y:hidden;background-color:#fff;display:flex;flex-direction:column}.privacy-policy .page-container[data-v-9341a17a]{box-sizing:border-box;background-color:#fff;flex:1}.privacy-policy .page-container .iframe[data-v-9341a17a]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
